import React from 'react';
import FormDialog from '../../../../library/form/components/FormDialog';
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormRichText from '../../../../library/form/components/FormRichText';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormROValue from '../../../../library/form/components/FormROValue1';

const RoleHeaderEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '175px' }}
            formStyle={{ width: '375px' }} formTitle={<FormTitle formObject={formObject} value="Role Header" />}
        >
            <div id="editor">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "roleId" }} value="Role ID" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "roleId" }}
                                id='svAddType' className="uiInline uiHeaderElement"
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "roleName" }} value="Role Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="streeAdd1Txt" className=" uiVal50p"
                                action={{ InputType: "input", paramName: "roleName" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "roleDesc" }} value="Role Description" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className=" uiVal50p" rows="3" cols="82"
                                action={{ paramName: "roleDesc" }}
                            />
                        </li>
                    </ul>
                </div>
        </FormDialog>
    )
}

export default withView(RoleHeaderEditor, "roleHead", "roleHead")